<template>
<div data-component="WebsocketsElement.vue">
	<div ref="SocketsContainer" class="[ sn-container ]" @animationend="OnNotificationAnimationEnd" @click="OnNotificationClick"/>
</div>
</template>

<script lang="ts">
import { mapState, mapStores } from 'pinia';
import emitter from 'tiny-emitter/instance';
import { useAppStore } from '@globals/stores/app';
import { useNotificationCountersStore } from '@globals/stores/notificationCounters';
import { useUserStore } from '@globals/stores/user';
import { WSNotification } from '@globals/types/Websockets';
import { addHandler } from '@globals/utilities/HandlerUtils';
import Websocket from '@globals/Websocket';

/**
 * Komponent odpowiedzialny za wyświetlanie powiadomień o nowych zleceniach i wiadomościach z czatu.
 * Dodatkowo, przesyła dalej wiadomości z Websocketa za pomocą `tiny-emitter`.
 */
export default {
	name: 'WebsocketsElement',
	data() {
		return {
			Socket: null,
			AudioData: 'data:audio/mpeg;base64,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',
			Audio: null,
			LastSocketMessage: {},
			OnlineStatusList: {},
			OnlineStatusElements: [],
		};
	},
	computed: {
		...mapState(useAppStore, ['sessionId', 'websocketUrl']),
		...mapStores(useUserStore),

		currentRfpId() {
			return Number(this.CurrentState.RfpId || this.$route.params.RfpId);
		},
		currentCustomerId() {
			return Number(this.CurrentState.CustomerId || this.$route.params.CustomerId);
		},
	},
	watch: {
		sessionId(n) { if (n) { this.CreateSocket(n); } },
	},
	mounted() {
		this.CreateSocket();
		this.Audio = new Audio(this.AudioData);
		this.Analytics.Socket = this.Socket;
		window.setInterval(() => {
			this.OnlineStatusListRefresh();
		}, 1000 * 15);
	},
	methods: {
		OnlineStatusListRefresh() {
			const current = [...document.querySelectorAll('.online-status[data-online-status]')].map((el) => el.getAttribute('data-online-status')).sort();
			const previous = this.OnlineStatusElements;
			if (!current.length) {
				this.OnlineStatusList = {};
			}

			if (current.join('|') !== previous.join('|')) {
				this.OnlineStatusElements = current;
				if (this.Socket) {
					this.Socket.Send({ type: 'OnlineStatus', data: { ids: current } });
				}
			}
		},
		OnOnlineStatusList(m) {
			const list = m.ids;
			this.OnlineStatusList = { ...this.OnlineStatusList, ...list };
		},
		CreateSocket() {
			if (!this.websocketUrl) { return; }
			this.Socket = new Websocket(this, this.sessionId, this.websocketUrl);
		},
		async OnSocketMessage(m) {
			// Ignoruj, jeżeli wiadomość jest duplikatem ~ bug związany z rozłączaniem się serwera przy np. restartach.
			const stringified = JSON.stringify(m.data);
			const excludeDuplicate = ['ChatMessageRead', 'ChatMessageTyping', 'NotificationCounters', 'RfpMatchingFinished', 'ChatAIRequest'];
			if (m.data && this.LastSocketMessage[m.type] === stringified && !excludeDuplicate.includes(m.type)) { return; }

			this.LastSocketMessage[m.type] = stringified;
			console.log(m.type);
			switch (m.type) {
				case 'Hello': this.Socket.Send({ type: 'NotificationCounters' }); break;
				case 'NotificationCounters': this.OnNotificationCounters(m.data); break;
				case 'Notification': this.OnNotification(m.data); break;
				case 'ChatMessage': emitter.emit('notification-chat-message', m.data); break;
				case 'Balance': this.OnBalance(m.data); break;
				case 'OnlineStatus': this.OnOnlineStatusList(m.data); break;
				case 'ChatMessageRead': emitter.emit('notification-chat-read', m.data); break;
				case 'ChatMessageTyping': emitter.emit('notification-chat-typing', m.data); break;
				case 'UncoverNotification': emitter.emit('notification-chat-read', m.data); break;
				case 'BuyerNotification': this.OnBell(); break;
				case 'Logout': await fetch('/j_acegi_logout'); document.location.href = '/logowanie'; break;
				case 'RfpCommentInCheck': emitter.emit('notification-customer-reviewed', m.data); break;
				case 'RfpMatchingFinished': this.RfpMatchingFinished(m.data); break;
				case 'RfpCustomerUncover': this.RfpCustomerUncover(m.data); break;
				case 'BuyerRfpActivation': emitter.emit('buyer-rfp-activated', m.data); break;
				case 'ChatAIRequest': emitter.emit('ai-valuation-ready', m.data); break;
				default: break;
			}
		},

		OnBalance(balanceData) {
			window.setTimeout(() => {
				emitter.emit('balance', balanceData);
			}, 500);
		},

		OnBell() {
			window.setTimeout(() => {
				emitter.emit('bell');
			}, 500);
		},

		ShowTotalChatMsgNotification(value: number) {
			// TODO: To powinno korzystać z userStora
			const element = document.querySelector('.navbar-counter[data-type="buyerAppTotalMsg"]');
			if (element) { element.innerText = value; }
		},

		// WebsocketNotifications.OnNotificationCounters({ rfps: 12, chats: [ 'XXX:XXX' ] })
		OnNotificationCounters(c) {
			if (!c) { return; }
			if (c.idChats) { c.chats = c.idChats; }
			const notificationCounters = useNotificationCountersStore();
			if (c.totalUnreadChatMessages && window.localStorage.getItem('isBuyerApp') === 'true') {
				this.ShowTotalChatMsgNotification(c.totalUnreadChatMessages);
			}
			if (c.chats !== undefined) {
				notificationCounters.newChatsList = c.chats;
				notificationCounters.newContacts = c.chats.length;
			}
			if (c.rfps !== undefined) {
				notificationCounters.newRfps = c.rfps;
			}

			notificationCounters.newRfps = c.rfps || 0;
			notificationCounters.newContacts = c.totalUnreadChatMessages || 0;

			notificationCounters.totalUnreadNotifications = notificationCounters.newRfps + notificationCounters.newContacts;
			this.ChangeWindowTitle(notificationCounters.totalUnreadNotifications);
		},

		// WebsocketNotifications.ChangeWindowCounter(12)
		ChangeWindowTitle(n) {
			try {
				let t = document.title;
				const match = (t.matchAll(/\((\d+)\) (.+)/g).next()).value;
				if (match && match.length === 3) { t = match.at(2); }
				document.title = (n > 0 ? `(${n}) ` : '') + t;
			} catch (err) {
				return false;
			}
			return true;
		},

		OnNotification(n: WSNotification) {
			if (this.CurrentModule === 'BuyerView' || this.CurrentModule === 'MobileBuyerAppPanel') {
				this.OnBell();
			}
			if (n.idChat) { this.OnChatNotification(n); return; }
			if (!n || !n.notificationType) { return; }
			const type = n.notificationType.toLowerCase();
			emitter.emit(`notification-${type}`, n);
			switch (type) {
				case 'rfp': this.OnRfpNotification(n); break;
				case 'chat': this.OnChatNotification(n); break;
				default: break;
			}
		},

		OnRfpNotification(n: WSNotification) {
			const notificationCounters = useNotificationCountersStore();
			n.idGroup = n.idRfp;

			// Nie wyświetlaj powiadomienia na tym samym RFP
			if (!this.PreventNotificationDisplay(n)) {
				this.DisplayNotification(n);
			}

			if (n.uncoverType && ['uncCustSK', 'uncBuyerAP'].indexOf(n.uncoverType) > -1) {
				this.OnNotificationCounters({
					chats: [...notificationCounters.newChatsList, n.idGroup],
					rfps: notificationCounters.newRfps,
				});
			} else {
				this.OnNotificationCounters({
					chats: notificationCounters.newChatsList,
					rfps: notificationCounters.newRfps + 1,
				});
			}
		},

		OnChatNotification(n: WSNotification) {
			const notificationCounters = useNotificationCountersStore();
			n.idGroup = n.idChat;
			if (!this.PreventNotificationDisplay(n)) {
				this.DisplayNotification(n);
				if (this.CurrentModule === 'CustomerView' && notificationCounters.newChatsList.indexOf(n.idGroup) === -1) {
					this.OnNotificationCounters({
						chats: [...notificationCounters.newChatsList, n.idGroup],
						rfps: notificationCounters.newRfps,
					});
				} else {
					this.OnNotificationCounters({
						chats: [...notificationCounters.newChatsList, n.idGroup],
						rfps: notificationCounters.newRfps,
					});
				}
			}

			emitter.emit('bv-websocket', { data: n, currentRfpId: this.currentRfpId });
			emitter.emit('chat-message-notification', n);
		},

		PreventNotificationDisplay(n: WSNotification) {
			if (this.CurrentModule === 'CustomerView') {
				return this.currentRfpId === n.idGroup || this.currentRfpId === n.idRfp;
			}
			return (this.currentRfpId === n.idGroup || this.currentRfpId === n.idRfp) && this.currentCustomerId === n.idCustomer;
		},

		OnNotificationAnimationEnd(e) {
			const $t = e.target;
			switch (e.animationName) {
				case 'sn-notification-enter': $t.className = 'is-staying'; break;
				case 'sn-notification-stay': $t.className = 'is-leaving'; break;
				case 'sn-notification-leave': $t.remove(); break;
				default: break;
			}
		},

		OnNotificationClick(e) {
			const $t = e.target;
			if ($t.matches('.sn-notification-close')) {
				e.preventDefault();
				$t.closest('a').className = 'is-leaving';
			}
		},

		PlayAudio() {
			try {
				const audio = new Audio();
				audio.autoplay = true;
				audio.src = this.AudioData;
			} catch (err) {}

			window.AudioIsPlaying = true;
			window.setTimeout(() => { window.AudioIsPlaying = false; }, 1000);
		},

		// WebsocketNotifications.DisplayNotification({ title: `Test`, message: 'Test' });
		DisplayNotification(n) {
			const $c = this.$refs.SocketsContainer;
			if (!n || !$c || !n.title) { return; }
			n.url = n.url || '';

			let sound = false;
			if (this.Audio && this.userStore.isCustomer && !(window.AudioIsPlaying || window.localStorage.DisableAudio === 'true')) {
				this.PlayAudio();
				sound = true;
			}

			// Nie pokazuj powiadomienia, jeżeli dotyczy aktualnie wyświetlanego rfp lub jeżeli istnieje this.currentCustomerId, to obecnie wyświetlanego chatu
			if (this.currentRfpId && n.url.indexOf(this.currentRfpId) > -1 && this.currentCustomerId === n.idCustomer) { return; }

			const $n = document.createElement('a');
			const separator = n.url.indexOf('?') > -1 ? '&' : '?';
			const deviceData = `deviceData=${window.matchMedia('(pointer: fine)').matches ? 'desktop' : 'mobile'}`;
			$n.href = (n.url || '') + separator + deviceData;
			$n.setAttribute('data-group-id', n.idGroup);

			if (n.image) {
				$n.setAttribute('data-style', 'rfp-with-image');

				let s = n.onlineStatus;
				s = s > 0 ? this.Format.TimeAgo(s) : s;

				let sex = n.customerPersonSex;
				sex = !sex ? '' : `data-sex="${sex === 'F' ? 'K' : 'M'}"`;
				n.image = `/images/hero/${n.image}-zlecenia-oferty-h.jpg`;

				$n.innerHTML = `
				<div class="sn-notification-image" style="background-image: url(${n.image})"></div>
				<div class="sn-notification-message-container">
					<div class="sn-notification-title">${n.title + (n.unreadMessages ? ` (${n.unreadMessages})` : '')}</div>
					<div class="sn-badges">
						<div class="sn-badge is-badge-person">${n.contactPersonName || ''}</div>
						<div class="sn-badge is-badge-location">${n.location || ''}</div>
						<div class="sn-badge is-badge-online-status" style="display:none!important">
							<div class="online-status" ${sex} data-status="${s}"></div>
						</div>
					</div>
					<div>${n.message || ''}</div>
				</div>
				<div class="sn-notification-close"></div>
			`;
			} else {
				$n.innerHTML = `
				<div class="sn-notification-title">${n.title + (n.unreadMessages ? ` (${n.unreadMessages})` : '')}</div>
				<div class="sn-notification-message">${n.message}</div>
				<div class="sn-notification-close"></div>
			`;
			}

			let eventLabel = 'other';
			if (n.notificationType === 'RFP') {
				switch (n.uncoverType) {
					case 'rfpNotify': eventLabel = 'rfp'; break;
					case 'uncCustSK':
					case 'uncBuyerSK': eventLabel = 'quick'; break;
					case 'uncCustAP':
					case 'uncBuyerAP': eventLabel = 'automatic'; break;
					case 'uncBuyerPF':
					case 'uncBuyerPFNew': eventLabel = 'recommendation'; break;
					default: break;
				}
			} else {
				eventLabel = 'chat';
			}

			addHandler($n, 'click', (e) => {
				if (e.target.classList.contains('sn-notification-close')) {
					e.preventDefault();
					$n.className = 'is-leaving';
					return;
				}

				this.Analytics.sendGAEvent(`websocket_click_${eventLabel}`, {
					is_sound_enabled: sound,
					id_rfp: n.idRfp,
				});

				const rfp = /\/(\d+)_/.exec($n.href) || '';
				if (rfp) {
					e.preventDefault();
					document.location.href = $n.href; // Powoduje przeładowanie całej strony, ale działa na publicznym podglądzie zapytania.
					$n.className = 'is-leaving';
				}
			});

			$n.style.bottom = '32px';
			$c.appendChild($n);
			this.Analytics.sendGAEvent(`websocket_show_${eventLabel}`, {
				is_sound_enabled: sound,
				id_rfp: n.idRfp,
			});
		},
		RfpMatchingFinished(data: { idRfp: number }) {
			if (this.currentRfpId === data.idRfp) {
				emitter.emit('notification-rfp-matching-finished', { idRfp: data.idRfp });
			}
		},
		RfpCustomerUncover(data: { idCustomer: number; idRfp: number }) {
			emitter.emit('bv-customer-uncover', { data, currentRfpId: this.currentRfpId });
		},
	},
};
</script>

<style lang="scss">

.sn-container {
	position: fixed;
	z-index: 8192;
	bottom: 0;
	left: 0;
	filter: drop-shadow(0 5px 16px rgba(0, 0, 0, 0.25));
}

.sn-container > * {
	position: absolute;
	bottom: 32px;
	left: 20px;
	width: 320px;
	padding: 13px 16px;
	border: 1px solid rgba(239, 125, 19, 0.5);
	background: rgba(255, 255, 255, 0.95);
	border-radius: 8px;
	color: var(--black);
	font-size: 12px;
	line-height: 1.15;
	text-decoration: none;
	transition: bottom 0.3s;
}

.sn-notification-title {
	overflow: hidden;
	padding-right: 16px;
	margin-bottom: 4px;
	font-weight: bold;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.sn-notification-close::after {
	position: absolute;
	z-index: 1;
	top: 0;
	right: 0;
	padding: 8px 12px;
	color: #ef7d13;
	content: '×';
	font-size: 24px;
	line-height: 1;
}

.sn-notification-message {
	display: -webkit-box;
	overflow: hidden;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}

@keyframes sn-notification-enter {
	from { opacity: 0; transform: translateY(16px); }
	to { opacity: 1; transform: translateY(0); }
}

@keyframes sn-notification-stay {
	from { opacity: 1; }
	to { opacity: 1; }
}

@keyframes sn-notification-leave {
	from { opacity: 1; }
	to { opacity: 0; }
}

.sn-container > * {
	animation: sn-notification-enter 0.3s !important;
}

.sn-container > *.is-staying {
	animation: sn-notification-stay 7s !important;
}

.sn-container > *.is-staying:hover {
	animation-play-state: paused !important;
}

.sn-container > *.is-leaving {
	animation: sn-notification-leave 0.3s !important;
	animation-fill-mode: forwards;
	pointer-events: none;
}

@media (max-width: 767px) {
	.sn-container > * {
		bottom: 0 !important;
		left: 4px;
		width: calc(100vw - 8px);
		border-bottom: none;
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
		transition-property: bottom, opacity;
	}

	.sn-container > *:not(:last-child) {
		box-shadow: none;
		opacity: 0;
	}

	.sn-badges {
		font-size: 12px !important;
	}
}

@media (min-width: 768px) {
	.sn-container > * {
		bottom: 32px;
		width: 440px;
		padding: 16px;
		font-size: 14px;
	}
}

.sn-container {
	/* Status aktywności */
	.online-status {
		display: inline-flex !important;
		align-items: center;
		line-height: 1;
		opacity: 0;
		transition: opacity 0.3s;
		vertical-align: middle;
	}

	.online-status[data-status] {
		opacity: 1;
	}

	.online-status::after {
		content: '-----------';
	}

	.online-status[data-status="-1"]::after {
		content: 'Aktywny(a) teraz';
	}

	.online-status[data-status="-1"][data-sex="M"]::after {
		content: 'Aktywny teraz';
	}

	.online-status[data-status="-1"][data-sex="K"]::after {
		content: 'Aktywna teraz';
	}

	@keyframes online-pulse {
		0% { box-shadow: 0 0 0 0 #e6ee9c; }
		70% { box-shadow: 0 0 0 4px #e6ee9c; }
		100% { box-shadow: 0 0 0 0 #e6ee9c; }
	}

	.online-status::before {
		width: calc(1em - 4px);
		height: calc(1em - 4px);
		margin-right: 4px;
		border-radius: 100%;
		box-shadow: inset 0 0 0 2px #8bc34a;
		content: '' !important;
	}

	.online-status[data-status="-1"]::before {
		animation: online-pulse 2s infinite;
		background: #8bc34a;
	}

	.online-status[data-status="0"]::before {
		box-shadow: inset 0 0 0 2px #9e9e9e;
	}

	.online-status[data-status]:not([data-status="-1"])::after {
		content: 'Aktywny(a) ' attr(data-status);
	}

	.online-status[data-status][data-sex="M"]:not([data-status="-1"])::after {
		content: 'Aktywny ' attr(data-status);
	}

	.online-status[data-status][data-sex="K"]:not([data-status="-1"])::after {
		content: 'Aktywna ' attr(data-status);
	}

	.online-status[data-status="0"]::after {
		content: 'Aktywny(a) 3+ dni temu' !important;
	}

	.online-status[data-status="0"][data-sex="M"]::after {
		content: 'Aktywny 3+ dni temu' !important;
	}

	.online-status[data-status="0"][data-sex="K"]::after {
		content: 'Aktywna 3+ dni temu' !important;
	}
}

/* with image */
.sn-container > *[data-style="rfp-with-image"] {
	min-height: 90px;
	padding: 12px 16px;
}

.sn-notification-message-container {
	margin-left: 72px;
}

.sn-badges {
	display: flex;
	flex-wrap: wrap;
	font-size: 13px;
}

.sn-badges > * {
	display: flex;
	align-items: center;
	margin-right: 8px;
	margin-bottom: 4px;
}

.sn-notification-image {
	position: absolute;
	top: 12px;
	left: 12px;
	width: 64px;
	height: 64px;
	background-size: cover;
	border-radius: 4px;
}

.sn-badges > *::before {
	display: inline-block;
	width: 16px;
	height: 16px;
	margin-right: 4px;
	background-size: contain;
	content: '';
	opacity: 0.5;
}

.sn-badges > .is-badge-person::before {
	background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDQuMjMzIDQuMjMzIj48ZyB0cmFuc2Zvcm09Im1hdHJpeCguMjY0NTggMCAwIC4yNjQ1OCAtLjk4OCAtMS4xMDUpIiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzk3OTc5NyIgc3Ryb2tlLXdpZHRoPSIyIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjkiIHI9IjMiIHN0cm9rZT0iIzAwMCIvPjxwYXRoIGQ9Ik0xMS43MyAxNC4zNTNsLTEuMTU4LjA2Yy0xLjk3NC4xOS0zLjg3Mi44NjUtNS41MiAxLjk3MmE4Ljk4MyA4Ljk4MyAwIDAwNi42OTUgMi45NjggMSAxIDAgMDAuMDAyIDAgOC45MyA4LjkzIDAgMDA2LjY2OC0yLjk2MyAxMS45NTcgMTEuOTU3IDAgMDAtNC44MDItMS44ODZsLTEuODgzLS4xNXoiIHN0cm9rZT0ibm9uZSIvPjwvZz48L3N2Zz4=);
}

.sn-badges > .is-badge-location::before {
	background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDQuMjMzIDQuMjMzIj48cGF0aCBkPSJNMi4xMTcuMzUzQTEuMjM0IDEuMjM0IDAgMDEzLjM1IDEuNTg3YzAgLjkyNy0xLjIzNCAyLjI5NC0xLjIzNCAyLjI5NFMuODgyIDIuNTE0Ljg4MiAxLjU4N0ExLjIzNCAxLjIzNCAwIDAxMi4xMTcuMzUzem0wIC43OTNhLjQ0MS40NDEgMCAxMDAgLjg4My40NDEuNDQxIDAgMDAwLS44ODN6Ii8+PC9zdmc+);
}

.sn-badges > .is-badge-online-status::before {
	width: 0;
}

.sn-badge:empty {
	display: none !important;
}
</style>
